// Web mock for react-native-file-viewer
const FileViewer = {
  open: async (path: string, options?: any): Promise<void> => {
    // On web, open the file in a new tab
    if (path.startsWith('http') || path.startsWith('blob:') || path.startsWith('data:')) {
      window.open(path, '_blank');
    } else {
      console.warn('[FileViewer Web] Cannot open local file path:', path);
    }
  },
};

export default FileViewer;
